import React from 'react';
import { Building2, TrendingUp } from 'lucide-react';

const PerformanceMetrics = ({ suppliers }) => {
  const calculateMetrics = () => {
    if (!suppliers || suppliers?.length === 0) {
      return {
        totalSuppliers: 0,
        activeSuppliers: 0
      };
    }

    const totalSuppliers = suppliers?.length;
    const activeSuppliers = suppliers?.filter(s => s?.status === 'active')?.length;
    
    return {
      totalSuppliers,
      activeSuppliers
    };
  };

  const metrics = calculateMetrics();

  const getActiveSupplierPercentage = () => {
    if (metrics?.totalSuppliers === 0) return 0;
    return Math?.round((metrics?.activeSuppliers / metrics?.totalSuppliers) * 100);
  };

  const metricsData = [
    {
      title: 'Total Suppliers',
      value: metrics?.totalSuppliers?.toString(),
      subtitle: `${metrics?.activeSuppliers} active`,
      icon: Building2,
      color: 'primary',
      trend: null
    },
    {
      title: 'Active Rate',
      value: `${getActiveSupplierPercentage()}%`,
      subtitle: 'Supplier availability',
      icon: TrendingUp,
      color: 'success',
      trend: null
    }
  ];

  const getColorClasses = (color) => {
    const colorMap = {
      primary: {
        bg: 'bg-primary/10',
        text: 'text-primary',
        icon: 'text-primary'
      },
      success: {
        bg: 'bg-success/10',
        text: 'text-success',
        icon: 'text-success'
      },
      warning: {
        bg: 'bg-warning/10',
        text: 'text-warning',
        icon: 'text-warning'
      },
      error: {
        bg: 'bg-destructive/10',
        text: 'text-destructive',
        icon: 'text-destructive'
      },
      muted: {
        bg: 'bg-muted',
        text: 'text-muted-foreground',
        icon: 'text-muted-foreground'
      }
    };
    return colorMap?.[color] || colorMap?.muted;
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {metricsData?.map((metric, index) => {
        const colors = getColorClasses(metric?.color);
        const IconComponent = metric?.icon;
        
        return (
          <div key={index} className="bg-card border rounded-lg p-4">
            <div className="flex items-center justify-between mb-3">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${colors?.bg}`}>
                <IconComponent className={`w-5 h-5 ${colors?.icon}`} />
              </div>
            </div>
            
            <div className="space-y-1">
              <p className="text-2xl font-bold text-foreground">{metric?.value}</p>
              <p className="text-xs font-medium text-foreground">{metric?.title}</p>
              <p className="text-xs text-muted-foreground">{metric?.subtitle}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PerformanceMetrics;